import { get } from "lodash";
import { createSelector } from "reselect";
import { getPageContent } from "../../shared/selectors";

const getProjectEmails = createSelector([getPageContent], pageContent => {
  return get(pageContent, "project_emails", []);
});

export default getProjectEmails;
